import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Field, reduxForm } from 'redux-form';
import { Button, ButtonToolbar, Card, CardBody, Col, Row } from 'reactstrap';
import { connect } from 'react-redux';
import EyeIcon from 'mdi-react/EyeIcon';
import { useParams } from 'react-router-dom';

const required = value => value ? undefined : 'Required'
const renderField = ({ input, label, placeholder, type, meta: { touched, error, warning } }) => (
  <div className="form__form-group">
    <div className="form__form-group">
      <input {...input} placeholder={placeholder} type={type} />
      {touched && ((error && <span className="form__form-group-error"> {label} {error}</span>) || (warning && <span>{warning}</span>))}
    </div>
  </div>
)
const ResetCurrentPasswordForm = ({ handleSubmit ,reset }) => {
  const [showPassword, setShowPassword] = useState(false);
  const [showPassword1, setShowPassword1] = useState(false);
  const [showPassword2, setShowPassword2] = useState(false);

  const showPasswordToggle = () => {
    setShowPassword(!showPassword);
  };
  const showPasswordToggle1 = () => {
    setShowPassword1(!showPassword1);
  };

  const showPasswordToggle2 = () => {
    setShowPassword2(!showPassword2);
  };

  let { userId } = useParams();

  return (

    <Card>
      <CardBody>
        <div>
          <h3 className="wizard__title">Reset Current Password</h3></div>

        <form className="form-animated" onSubmit={handleSubmit}>

          <Col lg={12} md={12}>
            {!userId &&
              <Row>
                <Col lg={4} md={4}>
                </Col>
                <Col lg={4} md={4}>
                  <div className="form__form-animated-group"><span className='required_field'>* </span>
                    <span className="form__form-animated-group-label">Current Password</span>
                    <div className="form__form-group-field">
                      <Field
                        validate={required}
                        name="currentPassword"
                        component={renderField}
                        type={showPassword ? 'text' : 'password'}
                        placeholder="Current Password"
                        className="input-without-border-radius" />
                      <button
                        type="button"
                        className={`form__form-group-button${showPassword ? ' active' : ''}`}
                        onClick={showPasswordToggle}
                      ><EyeIcon />
                      </button>
                    </div>
                  </div>
                </Col>
              </Row>
            }
            <Row>
              <Col lg={4} md={4}>
              </Col>
              <Col lg={4} md={4}>
                <div className="form__form-group"><span className='required_field'>* </span>
                  <span className="form__form-group-label">New Password</span>
                  <div className="form__form-group-field">

                    <Field
                      validate={required}
                      name="password"
                      component={renderField}
                      type={showPassword1 ? 'text' : 'password'}
                      placeholder="New Password"
                      className="input-without-border-radius" />
                    <button
                      type="button"
                      className={`form__form-group-button${showPassword1 ? ' active' : ''}`}
                      onClick={showPasswordToggle1}
                    ><EyeIcon />
                    </button>
                  </div>
                </div>

              </Col>
            </Row>
            <Row>
              <Col lg={4} md={4}>
              </Col>
              <Col lg={4} md={4}>
                <div className="form__form-group"><span className='required_field'>* </span>
                  <span className="form__form-group-label">Confirm Password</span>
                  <div className="form__form-group-field">
                    <Field name="confirmPassword" type={showPassword2 ? 'text' : 'password'} placeholder="Confirm Password" component={renderField} validate={required} />
                    <button
                      type="button"
                      className={`form__form-group-button${showPassword2 ? ' active' : ''}`}
                      onClick={showPasswordToggle2}
                    ><EyeIcon />
                    </button>
                  </div>
                </div>
              </Col>
            </Row>
          </Col>
          <div className="form__OnboardingButton">
            <ButtonToolbar className="form__button-toolbar wizard__toolbar">
              <Button color="primary" type="submit" className="next" onClick={handleSubmit}>Submit</Button>
            </ButtonToolbar>
          </div>
        </form>
      </CardBody>
    </Card>


  );
};

ResetCurrentPasswordForm.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
  reset: PropTypes.func.isRequired,
};


const mapStateToProps = (state) => ({});

export default connect(mapStateToProps)(reduxForm({ form: 'createModuleForm', enableReinitialize: true })(ResetCurrentPasswordForm))
